// src/components/DayBar.js
import React from "react";
import { Button, DatePicker, Space, Typography } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

function toISO(d) {
  return dayjs(d).format("YYYY-MM-DD");
}

// `light`: usado nas telas de fundo claro (a visão em lista).
// Sem ele, mantém o texto claro do painel escuro (visão de mapa).
export default function DayBar({ day, onChange, light = false }) {
  const current = dayjs(day);

  return (
    <Space>
      <Button onClick={() => onChange(toISO(current.subtract(1, "day")))}>
        ◀ Ontem
      </Button>

      <DatePicker
        value={current}
        onChange={(v) => v && onChange(toISO(v))}
        format="DD/MM/YYYY"
      />

      <Button onClick={() => onChange(toISO(dayjs()))}>Hoje</Button>

      <Button onClick={() => onChange(toISO(current.add(1, "day")))}>
        Amanhã ▶
      </Button>

      <Text
        style={{
          color: light ? "#5f6368" : "rgba(255,255,255,.65)",
        }}
      >
        {day}
      </Text>
    </Space>
  );
}
